import { render, staticRenderFns } from "./PicSlider.vue?vue&type=template&id=0b9004b0&scoped=true&"
import script from "./PicSlider.vue?vue&type=script&lang=ts&"
export * from "./PicSlider.vue?vue&type=script&lang=ts&"
import style0 from "./PicSlider.vue?vue&type=style&index=0&id=0b9004b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9004b0",
  null
  
)

export default component.exports